

<script >
import { reactive, toRefs, ref, computed, onMounted } from 'vue'
import * as THREE from 'three';
import { scene, renderer, CSS3renderer } from '../render/render.js'
import { camera, cubeCamera } from '../render/camera.js'
import { zeroM } from './material/zeroM.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { manager } from '../load/manager.js'
import { backimg, envImg } from '../img/textureLoad.js'
// import { point } from '../data/mapPoint.json'//定义整个节点分布得json数据
// import { point } from '/public/mapData/mapPointz.json'//定义整个节点分布得json数据



//异步ajx读取json文件反vue打包操作

//引入文字库插件
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { createCube } from './model/cube'
import { createCube3 } from './model/chlikCube.js'
import { Tween } from 'three/examples/jsm/libs/tween.module.js'

import { raycaster, pointer } from './chilck.js'
// import {  } from 'three/examples/jsm/helpers/VertexNormalsHelper.js'
// import {  } from 'three/examples/jsm/helpers/VertexTangentsHelper.js'

//引入变化ui
import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js';
import { CSS3DRenderer, CSS3DSprite, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer.js';
//导入我们得自定义json数据
import tilteR from '../data/jifang.json'

// "computRoom": [  json 的数据格式-------------------
//         {
//             "id": "工业主机A1",
//             "name": "起重机",
//             "power": "125"
//         },---------------------------------------
// console.log(tilteR);
// console.log(tilteR.computRoom[0]);


let Tag = {
    div: [],
    threeDdiv: [],
    string: [],
    size: 0.1,
    FthreeDdiv: [],
    objMain: new THREE.Group,
    btn: null,
    opcl: true
}
let Tagh = {
    cSize: 0.15,
    strDiv: { q: [], h: [] },
    str: { q: [], h: [] },
    div: [],
    threeDdiv: [],
    string: [],
    size: 0.1,
    FthreeDdiv: [],
    objMain: new THREE.Group,
    btn: null,
    opcl: true
    // addTagdivH=(srcq,srch, id)//调用函数结构方便书写观察
}

let heightLight = {
    tex: null,
    plan: [],
    offset: { x: 0.5, y: 0 },
    position: { x: [], y: [], z: [] },
    simpleObj: null,
    objMain: new THREE.Group,
    planeMain: null,
    clickobj: { d1: [], d2: [], c1: [], c2: [], b1: [], b2: [], a1: [], a2: [] },
}



// let bigSize = {
//     offsetx: 0.12,
//     offsety: 0.23,
//     xyADD: 1.5
// }
//注册vue插件
export default {


    data() {
        return {
            // your data properties here
            jindu: true
        }
    },
    methods: {
        hideLoading() {
            this.jindu = false;
        }

    },
    computed: {
        showLoading() {
            return this.jindu;
        }
    },
    mounted() {
        // 组件渲染完成后执行的代码vue2.0
        // console.log('组件加载完成钩子');

        scene.add(new THREE.GridHelper(2600, 18, 0x595959, 0x333333));
        //添加网格线条

        let css3canvas = document.getElementById('css3Tag')

        css3canvas.appendChild(CSS3renderer.domElement);
        // CSS3renderer.domElement.style.pointerEvents = "none";



        // function css3render() {
        //     // CSS3renderer.render(scene, camera);
        //     requestAnimationFrame(css3render)
        // }
        // css3render()

        //添加标签css代码


        Tag.div[0] = document.getElementById('tagS')
        //这里做cssobj得时候把序列为0得标签作为样本
        Tag.string = ['机房1']
        Tag.div[0].innerHTML = Tag.string[0]
        Tag.threeDdiv[0] = new CSS3DObject(Tag.div[0])
        Tag.threeDdiv[0].scale.set(0, 0, 0)


        //这里做cssobj得时候把序列为0得标签作为样本
        Tagh.div[0] = document.getElementById('tagK')
        Tagh.strDiv.q[0] = Tagh.div[0].querySelector('p');//选择dom节点下面得p标签
        Tagh.str.q[0] = '起重机'
        Tagh.str.h[0] = '用电量500KW.H'
        Tagh.strDiv.q[0].innerHTML = Tagh.str.q[0] + '<span style="color: aqua;">' + Tagh.str.h[0] + '</span>'
        Tagh.threeDdiv[0] = new CSS3DObject(Tagh.div[0])
        Tagh.threeDdiv[0].scale.set(Tagh.cSize, Tagh.cSize, Tagh.cSize)
        Tagh.threeDdiv[0].rotation.y = Math.PI / 2;
        Tagh.threeDdiv[0].position.y += 70
        Tagh.threeDdiv[0].scale.set(0, 0, 0)//重置0号样本
        scene.add(Tagh.threeDdiv[0])
        // console.log(Tag.threeDdiv[0]);
        const addTagdivH = (srcq, srch, id, Wv, Hv) => {
            Tagh.string[id] = srcq + '<span style="color: aqua;">用电量' + srch + 'KW.H</span>'
            Tagh.div[id] = Tagh.div[0].cloneNode(true)//复制div dom
            Tagh.strDiv.q[id] = Tagh.div[id].querySelector('p');//选择dom节点下面得p标签
            //    console.log(       Tagh.strDiv.q[id]);
            //清除冒泡事件
            Tagh.div[id].style.pointerEvents = "none";
            Tagh.strDiv.q[id].style.pointerEvents = "none";

            //添加自定义文本
            Tagh.strDiv.q[id].innerHTML = Tagh.string[id]
            //创建css3对象
            Tagh.threeDdiv[id] = new CSS3DObject(Tagh.div[id])
            Tagh.threeDdiv[id].scale.set(Tagh.cSize, Tagh.cSize, Tagh.cSize)
            Tagh.threeDdiv[id].rotation.y = Math.PI / 2;
            // Tagh.div[id].style.width = Wv + 'px'
            // Tagh.div[id].style.height = Hv + 'px'
            return Tagh.threeDdiv[id]

        }

        function addTagdiv(src, id, Wv, Hv) {
            Tag.string[id] = src
            Tag.div[id] = Tag.div[0].cloneNode(true)
            Tag.div[id].style.width = Wv + 'px'
            Tag.div[id].style.height = Hv + 'px'
            Tag.div[id].style.pointerEvents = "none";
            Tag.div[id].innerHTML = Tag.string[id]
            Tag.threeDdiv[id] = new CSS3DObject(Tag.div[id])
            Tag.threeDdiv[id].userData.pointerEvents = false
            Tag.threeDdiv[id].scale.set(Tag.size, Tag.size, Tag.size)
            Tag.threeDdiv[id].rotation.y = Math.PI / 2;
            return Tag.threeDdiv[id]
        }
        scene.add(Tag.threeDdiv[0])




        // console.log( Tag.FthreeDdiv[1]);

        //______________________________________________________
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('./glb/draco/');
        dracoLoader.setDecoderConfig({ type: 'js' });
        dracoLoader.setPath('./glb/');

        var loader = new GLTFLoader(manager); //创建一个GLTF加载
        loader.setPath('./glb/');
        loader.setDRACOLoader(dracoLoader);

        const glbsence = {
            obj: [],
            loadj: [],
            load: 0
        }
        // let jindu = ref(true)
        // let jindu=true
        const clickCube1 = createCube(2.5, 0x39CC8C);
        clickCube1.scale.set(1, 4, 1)
        clickCube1.position.set(0, 5, 0)
        clickCube1.material.opacity = 0
        scene.add(clickCube1)
        // console.log(point[2].name);


        //机房主要
        loader.load(
            // resource URL
            '机房.glb',
            function (gltf) {
                glbsence.obj[0] = gltf.scene
                scene.add(gltf.scene)
                gltf.scene.traverse(function (child) {


                    if (child.isLineSegments) {
                        //筛选出线条
                        if (child.material.name == '电脑桌1.001') {
                            // console.log(child);
                            child.material.wireframe = true
                            child.material.blending = THREE.AdditiveBlending
                            child.material.opacity = 0.3
                            // child.material.color=new THREE.Color( 0x03142b);
                        }

                    }
                    if (child.name == '高光') {
                        heightLight.planeMain = child
                    }


                    if (child.isMesh) { //筛选mesh
                        if (child.material.name == '门外壳单独') {
                            // console.log(child);
                            // child.material.wireframe = true
                            child.material.blending = THREE.AdditiveBlending
                            // child.material.color=new THREE.Color( 0x03142b);
                        }
                        if (child.material.name == '配电箱.') {
                            // console.log(child);
                            // child.material.color=new THREE.Color( 0xffffff);
                            // child.material.emissiveIntensity=2.0
                            child.material.roughness = 0.45
                            child.material.emissive = new THREE.Color(0x33616b);
                            child.material.emissiveMap = child.material.map
                        }

                        if (child.parent.name == '高光') {
                            // console.log(child.material.name);
                            child.material.opacity = 0.45
                            child.material.blending = THREE.AdditiveBlending
                            child.material.opacity = 0
                            child.material.depthWrite = false
                            // zeroM.depthWrite = false
                            // zeroM.flatShading = false
                            heightLight.tex = child.material.map
                            // console.log( heightLight.tex);
                            if (child.name == 'a1') {
                                heightLight.plan[0] = child
                                // console.log(child);

                            }
                            if (child.name == 'a2') {
                                heightLight.plan[1] = child
                            }
                            if (child.name == 'b1') {
                                heightLight.plan[2] = child
                            }
                            if (child.name == 'b2') {
                                heightLight.plan[3] = child
                            }
                            if (child.name == 'c1') {
                                heightLight.plan[4] = child
                            }
                            if (child.name == 'c2') {
                                heightLight.plan[5] = child
                            }
                            if (child.name == 'd1') {
                                heightLight.plan[6] = child
                            }
                            if (child.name == 'd2') {
                                heightLight.plan[7] = child
                            }

                        }




                        child.layers.enable(0);
                    }


                })

                // console.log( heightLight.plan[0]);
                // heightLight.tex.wrapS = THREE.RepeatWrapping;
                // heightLight.tex.wrapT = THREE.RepeatWrapping;
                // heightLight.tex.repeat.set( 1, 1 );
                // heightLight.tex.offset =new THREE.Vector2( heightLight.offset.x, heightLight.offset.y );
                // heightLight.plan[0].material.map=heightLight.tex

                heightLight.plan[1].material.map.offset = new THREE.Vector2(heightLight.offset.x, heightLight.offset.y);

                // heightLight.plan[0].material.opacity = 1

                heightLight.position.a1 = [0.4764, 0.5724, 0.6534, 0.7344, 0.8232, 0.9114, 0.978]
                heightLight.position.a2 = [0.4764, 0.5724, 0.6534, 0.7344, 0.8232, 0.9114, 0.978]
                heightLight.position.b1 = [0.4764, 0.5724, 0.6534, 0.7344, 0.8232, 0.9114, 0.978]
                heightLight.position.b2 = [0.4764, 0.5724, 0.6534, 0.7344, 0.8232, 0.9114, 0.978]
                heightLight.position.c1 = [0.4764, 0.5724, 0.6534, 0.7344, 0.8232, 0.9114, 0.978]
                heightLight.position.c2 = [0.4764, 0.5724, 0.6534, 0.7344, 0.8232, 0.9114, 0.978]
                heightLight.position.d1 = [0.4764, 0.5724, 0.6534, 0.7344, 0.8232, 0.9114, 0.978]
                heightLight.position.d2 = [0.4764, 0.5724, 0.6534, 0.7344, 0.8232, 0.9114, 0.978]


                // let gui = new GUI();//添加ui调试
                // let changeTexture = {
                //     'a1贴图偏移x': 0.5,
                //     '贴图偏移y': 0
                // }
                // gui.add(changeTexture, 'a1贴图偏移x', 0.4, 1).onChange(function (val) {
                //     heightLight.plan[1].material.map.offset = new THREE.Vector2(val, heightLight.offset.y);

                // })

                //增加点击交互容器box

                heightLight.simpleObj = createCube3(8.473, 31.957, 15.062, 0xffffff)


                const addChilkCube = (x, y, z, name, rongqi) => {
                    rongqi[0] = heightLight.simpleObj.clone()
                    rongqi[0].material = heightLight.simpleObj.material.clone()
                    rongqi[0].name = name + 0
                    rongqi[0].material.name = '材质' + name + 0
                    rongqi[0].position.set(x, y, z)
                    heightLight.objMain.add(rongqi[0])

                    for (let i = 0; i < 6; i++) {
                        rongqi[i + 1] = rongqi[0].clone()
                        rongqi[i + 1].material = rongqi[0].material.clone()
                        rongqi[i + 1].name = name + (i + 1)
                        rongqi[i + 1].material.name = '材质' + name + (i + 1)
                        rongqi[i + 1].position.z = rongqi[0].position.z - (i + 1) * 15.062
                        heightLight.objMain.add(rongqi[i + 1])
                        // console.log(1);
                    }
                    //重置材质让材质不在场景显示只做交互操作
                    for (let a = 0; a < 7; a++) {
                        rongqi[a].material.transparent = true
                        rongqi[a].material.opacity = 0
                        rongqi[a].material.depthWrite = false
                        rongqi[a].material.flatShading = false
                    }
                }


                addChilkCube(-42.331, 16.749, 83.166, 'a1模型', heightLight.clickobj.a1)
                addChilkCube(-42.331, 16.749, -32.130, 'a2模型', heightLight.clickobj.a2)

                addChilkCube(-13.446, 16.749, 83.166, 'b1模型', heightLight.clickobj.b1)
                addChilkCube(-13.446, 16.749, -32.130, 'b2模型', heightLight.clickobj.b2)

                addChilkCube(16.567, 16.749, 84.377, 'c1模型', heightLight.clickobj.c1)
                addChilkCube(16.567, 16.749, -31.939, 'c2模型', heightLight.clickobj.c2)

                addChilkCube(45.825, 16.749, 83.051, 'd1模型', heightLight.clickobj.d1)
                addChilkCube(45.825, 16.749, -31.939, 'd2模型', heightLight.clickobj.d2)


                heightLight.simpleObj.material.transparent = true
                heightLight.simpleObj.material.opacity = 0
                heightLight.simpleObj.material.depthWrite = false
                heightLight.simpleObj.material.flatShading = false

                //隐藏样本的模型的显示材质

                const resetMatrial = () => {
                    heightLight.planeMain.traverse(function (child) {
                        if (child.isMesh) {

                            child.material.blending = THREE.AdditiveBlending
                            child.material.opacity = 0
                            child.material.depthWrite = false
                            if (child.name == 'a1') {
                                child.material = child.material.clone()
                                child.material.name = 'a1灯'//材质名字美术阶段做错了，在这里用代码克隆修正一下
                            }
                        }
                    })
                }


                // console.log(heightLight.objMain.children);
                scene.add(heightLight.objMain)



                const setComputerName = (obj) => {
                    let tc = {
                        hang: obj.name.substring(0, 2).toUpperCase(),
                        //提取字符串前面两位，并且吧字符串得小写英文字母变成大写
                        lie: obj.name.slice(-1)
                        //提取字符串最后1位
                    }
                    let name = tc.hang + '变压器' + tc.lie
                    return name
                }


                const setComputerNamej = (obj) => {
                    let tc = {
                        hang: obj.name,
                        //提取字符串前面两位，并且吧字符串得小写英文字母变成大写
                        lie: obj.id
                        //提取字符串最后1位
                    }
                    let name = tc.hang + '主机'
                    return name
                }
                for (let c = 0; c < heightLight.objMain.children.length; c++) {

                    // Tag.FthreeDdiv[c + 1] = addTagdiv(setComputerName(heightLight.objMain.children[c]), c, 80, 40)

                    Tag.FthreeDdiv[c + 1] = addTagdiv(setComputerNamej(tilteR.computRoom[c]), c)
                    Tagh.FthreeDdiv[c + 1] = addTagdivH(tilteR.computRoom[c].name,
                        tilteR.computRoom[c].power, c, 40, 20)
                }
                // console.log(  Tagh.FthreeDdiv[5] );
                // Tag.FthreeDdiv[2 + 1].position.set(-38.663,18.700,0.000)
                for (let d = 0; d < heightLight.objMain.children.length; d++) {
                    Tag.FthreeDdiv[d + 1].position.set(heightLight.objMain.children[d].position.x
                        , heightLight.objMain.children[d].position.y, heightLight.objMain.children[d].position.z)


                    Tag.FthreeDdiv[d + 1].position.y += 22

                    Tag.objMain.add(Tag.FthreeDdiv[d + 1])

                    Tagh.FthreeDdiv[d + 1].position.set(heightLight.objMain.children[d].position.x
                        , heightLight.objMain.children[d].position.y, heightLight.objMain.children[d].position.z)
                    //    console.log( heightLight.objMain.children[d].position);
                    Tagh.FthreeDdiv[d + 1].position.y += 45
                    Tagh.FthreeDdiv[d + 1].scale.set(0, 0, 0)

                    Tagh.objMain.add(Tagh.FthreeDdiv[d + 1])


                }

                scene.add(Tag.objMain)
                scene.add(Tagh.objMain)

                const restbigTile = () => {
                    for (let d = 0; d < heightLight.objMain.children.length; d++) {
                        Tagh.FthreeDdiv[d + 1].scale.set(0, 0, 0)
                    }
                }

                const openF = () => {
                    // console.log('点击了');
                    if (Tag.opcl) {
                        Tag.objMain.scale.set(0, 0, 0)
                    } else {
                        Tag.objMain.scale.set(1, 1, 1)
                    }

                    Tag.opcl = !Tag.opcl;
                }

                Tag.btn = document.getElementById('ui-btn')
                Tag.btn.addEventListener('pointerdown', openF)
                // console.log(Tag.btn);

                const updateC = () => {
                    for (let c = 0; c < Tag.objMain.children.length; c++) {
                        Tag.objMain.children[c].lookAt(camera.position)
                        Tagh.FthreeDdiv[c + 1].lookAt(camera.position)
                    }

                    requestAnimationFrame(updateC)//定义标签始终朝向摄像机 更新函数
                }
                updateC()

                heightLight.simpleObj.position.y = 31.957 / 2
                // scene.add(heightLight.simpleObj)
                const Rayrender = () => {
                    // console.log('点击事件执行情况');
                    raycaster.setFromCamera(pointer, camera);
                    const intersects = raycaster.intersectObjects(heightLight.objMain.children);

                    for (let i = 0; i < intersects.length; i++) {
                        if (i == 0) {

                            let cc = {
                                hang: intersects[i].object.name.substring(0, 2),
                                lie: intersects[i].object.name.slice(-1)
                            }

                            //   console.log(cc);
                            const changeLiahgt = (str, num) => {
                                if (cc.hang == str) {
                                    resetMatrial()
                                    heightLight.plan[num].material.map.offset = new THREE.Vector2(
                                        heightLight.position.a1[cc.lie], heightLight.offset.y);
                                    heightLight.plan[num].material.opacity = 0.45

                                }

                            }

                            // console.log(cc);

                            const restID = () => {
                                let id = {
                                    num: 0,
                                    end: null
                                }
                                if (cc.hang == 'a1') {
                                    id.num = 0 + parseInt(cc.lie)
                                }
                                if (cc.hang == 'a2') {
                                    id.num = 7 + parseInt(cc.lie)
                                }
                                if (cc.hang == 'b1') {
                                    id.num = 7 * 2 + parseInt(cc.lie)
                                }
                                if (cc.hang == 'b2') {
                                    id.num = 7 * 3 + parseInt(cc.lie)
                                }
                                if (cc.hang == 'c1') {
                                    id.num = 7 * 4 + parseInt(cc.lie)
                                }
                                if (cc.hang == 'c2') {
                                    id.num = 7 * 5 + parseInt(cc.lie)
                                }
                                if (cc.hang == 'd1') {
                                    id.num = 7 * 6 + parseInt(cc.lie)
                                }
                                if (cc.hang == 'd2') {
                                    id.num = 7 * 7 + parseInt(cc.lie)
                                }
                                id.end = id.num
                                return id.end
                            }

                            restbigTile()

                            Tagh.FthreeDdiv[restID() + 1].scale.set(Tagh.cSize, Tagh.cSize, Tagh.cSize)
                            // console.log(restID());


                            changeLiahgt('a1', 0)
                            changeLiahgt('a2', 1)
                            changeLiahgt('b2', 2)
                            changeLiahgt('b1', 3)
                            changeLiahgt('c1', 4)
                            changeLiahgt('c2', 5)
                            changeLiahgt('d1', 6)
                            changeLiahgt('d2', 7)

                        }

                    }
                    renderer.render(scene, camera);

                }

                // window.addEventListener('pointerdown', Rayrender);

                //防止误点函数封装
                // 存储 鼠标按下时的二维空间点
                let onDownPosition = new THREE.Vector2();
                // 存储 鼠标松开时的二维空间点
                let onUpPosition = new THREE.Vector2();
                // 鼠标按键按下时触发的事件
                let onPointerdown = (event) => {
                    onDownPosition.x = event.clientX;
                    onDownPosition.y = event.clientY;

                }
                // 鼠标按键松开时触发的事件（相当于点击事件触发）
                let onPointerup = (event) => {
                    onUpPosition.x = event.clientX;
                    onUpPosition.y = event.clientY;
                    if (onDownPosition.distanceTo(onUpPosition) === 0) {
                        window.addEventListener('pointerdown', Rayrender);
                    } else {
                        window.removeEventListener('pointerdown', Rayrender);
                    }
                }
                window.addEventListener('pointerup', onPointerup, false);
                window.addEventListener('pointerdown', onPointerdown, false);


            },

            function (xhr) {

                  console.log(xhr.loaded);
                //   console.log(xhr );
                // console.log( ( xhr.loaded / xhr.total * 100 ) + '% 地图得加载进度' );
                glbsence.loadj[0] = Math.floor(xhr.loaded / xhr.total * 100)
                // console.log(glbsence.loadj[0]+ '% 1号模型加载进度');
            },

        );


        manager.onProgress = function (url, itemsLoaded, itemsTotal) {
            //   UidApp.loadWidthev = itemsLoaded / itemsTotal * 1//环境加载速度---

            // console.log('载入的模型: ' + url + '.\n目前已加载项的个数 ' + itemsLoaded + ' 总共所需要加载项的个数 '
            //   + itemsTotal + ' 文件进度');
            let jinduDiv = document.getElementById("bg");
            let loadjDom = document.getElementById('load')
            loadjDom.style.width = itemsLoaded / itemsTotal * 500 + 'px'


            if (itemsLoaded == itemsTotal) {
                console.log('加载检测陈宫+');
                this.jindu = false

                jinduDiv.style.display = "none";

            }


        };

        //侦测器得加载测试
        manager.onLoad = function () {

            // console.log(glbsence.text[0]);
            console.log('加载成功load');
            this.jindu = false
            let jinduDiv = document.getElementById("bg");
            jinduDiv.style.display = "none";

        }

      



    }
}


</script>
<template>
    <div>
        <div id="css3Tag"></div>

        <div id="ui">
            <button id="ui-btn" style="width: 100px;height: 30px;">点击显示ui</button>
        </div>

        <!-- 定义每个主机，显示的标签 -->
        <div id="tagS">
            <div>机房1</div>
        </div>

        <!-- 定义每个主机，点击交互后的标签 -->
        <div id="tagK">
            <div id="tagBG"></div>
            <p id="tagText">龙门吊 <span style="color: aqua;">用电量125KW.H</span></p>

            <div style="width: 2px;height: 250px;background-color: rgb(48, 60, 70);
            position: absolute;left: 198px;top: 130px;"></div>
        </div>

        <div id="bg">
            <div class="box">
                <div id="load">
                </div>
            </div>
            <div class="tex">
                <span>地图程序加载中</span>
            </div>
        </div>
    </div>
</template>

<style  scoped lang='less'>
#tagK {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 400px;
    height: 380px;
    border: rgb(255, 0, 64) solid 0px;
    pointer-events: none;

    #tagBG {
        position: absolute;
        left: 0px;
        top: 0px;
        background: url(./tip.png) no-repeat;
        background-size: 400px;
        width: 400px;
        height: 147px;
        border: rgb(68, 0, 255) solid 0px;
        pointer-events: none;
    }

    #tagText {
        position: absolute;
        width: 400px;
        height: 147px;
        left: 0px;
        top: 0px;
        color: white;
        text-align: center;
        font-size: 20px;
        height: 147px;
        line-height: 147px;
        pointer-events: none;


    }


}


#css3Tag {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: absolute;
    top: 0px;
    left: 0px;
    pointer-events: none;

}



#tagS {
    font-size: 10px;
    top: 0px;
    left: 0px;
    font-family: Arial;
    width: 140px;
    height: 50px;
    text-align: center;
    line-height: 40px;
    border: #6d6d6d 0.01px solid;
    color: #fff;
    pointer-events: none;
    font-weight: bold;
    box-shadow: inset 0px 1px 0px 0px #7ab98f;
    //   background: linear-gradient(#010755, #01011f);
    background-color: rgba(14, 14, 14, 0.5);
    opacity: 1;
    position: absolute;

    margin: 0 auto;
    float: left;
}

#ui {
    position: absolute;
    top: 0px;
    right: 0px;
}

#bg {
    background-color: rgb(0, 10, 37);
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0px;
    right: 0px;
}

.box {
    width: 500px;
    height: 20px;
    border: 1px solid #979797;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -250px;
    margin-top: -1px;
}

#load {
    // @loadWidth: 0;
    width: 0px;
    height: 20px;
    background: #ffffff;
}

.tex {
    color: aliceblue;
    font-size: 30px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -250px;
    margin-top: 23px;
}
</style>





